import useModalsStore from "../../store/modalsStore";
import NewTaskModal from "../NewTaskModal/NewTaskModal";
import NewLinkModal from "../NewLinkModal/NewLinkModal";
import ConfirmDialog from "../ConfirmDialog/ConfirmDialog";
import useHistoryStore from "../../store/historyStore";
import { useNavigate } from "react-router-dom";
import CanvasModal from "./CanvasModal";
import MoneyTransferModal from "src/pages/NewTransaction/MoneyTransferModal";
import useMainFilter from "src/hooks/useMainFilter";
import TransactionsSearchModal from "./TransactionsSearchModal";
import TableSettingsModal from "./TableSettingsModal";
import useCurrentUser from "src/hooks/useCurrentUser";
import useAllTransactions from "src/hooks/useAllTransactions";
import CurrentUserQrContact from "../CurrentUserQrContact/CurrentUserQrContact";
import RegisterPassKeyModal from "../RegisterPassKeyModal/RegisterPassKeyModal";
import ChangePasswordModal from "../ChangePasswordModal/ChangePasswordModal";
import { useMemo, useTransition } from "react";
import { EButtonKind } from "../Button/ButtonTypes";

const ModalsLoader: React.FC = () => {
  const { isLoadingAccounts } = useCurrentUser();
  const { isLoadingAllTransactions } = useAllTransactions();
  const navigate = useNavigate();
  const {
    setShowCreateNewAccount,
    showCreateNewAccount,
    setShowCreateNewTask,
    showCreateNewTask,
    showCreateNewLink,
    setShowCreateNewLink,
    setShowEditProfile,
    showEditProfile,
    showEditAccount,
    setShowEditAccount,
    showDeleteHistoryConfirm,
    setShowDeleteHistoryConfirm,
    setShowLogoutDialog,
    showLogoutDialog,
    showCreateNewCanvas,
    setShowCreateNewCanvas,
    showMoneyTransferModal,
    setShowMoneyTransferModal,
    showSearchModal,
    setShowSearchModal,
    showTableSettingsModal,
    setShowTableSettingsModal,
    showContactQrCode,
    showCreatePassKey,
    setShowCreatePassKey,
    showChangePassword,
    setShowChangePassword,
  } = useModalsStore();

  const { clearHistory } = useHistoryStore();
  const [isPending, startTransition] = useTransition();
  const { mainFilter, setMainFilter } = useMainFilter();

  const isLoadingSomething = useMemo(
    () => [!!isLoadingAccounts, !!isLoadingAllTransactions].includes(true),
    [isLoadingAccounts, isLoadingAllTransactions]
  );

  if (isLoadingSomething) return null;

  return (
    <>
      {showCreateNewTask && (
        <NewTaskModal
          onClose={() => startTransition(() => setShowCreateNewTask(false))}
        />
      )}

      {showCreateNewLink && (
        <NewLinkModal
          onClose={() => startTransition(() => setShowCreateNewLink(false))}
        />
      )}

      {showDeleteHistoryConfirm && (
        <ConfirmDialog
          description="¿Deseas limpiar tu historial?"
          title="Limpiar historial"
          onConfirm={() =>
            startTransition(() => {
              clearHistory();
              setShowDeleteHistoryConfirm(false);
            })
          }
          onClose={() =>
            startTransition(() => setShowDeleteHistoryConfirm(false))
          }
          confirmKind={EButtonKind.DANGER}
        />
      )}

      {showLogoutDialog && (
        <ConfirmDialog
          description="¿Deseas cerrar tu sesión?"
          onClose={() => startTransition(() => setShowLogoutDialog(false))}
          onConfirm={() =>
            startTransition(() => {
              setShowLogoutDialog(false);
              navigate("/logout");
            })
          }
          title="Salir"
        />
      )}

      {showCreateNewCanvas && (
        <CanvasModal
          onClose={() => startTransition(() => setShowCreateNewCanvas(false))}
        />
      )}

      {showMoneyTransferModal && (
        <MoneyTransferModal
          disableFields={false}
          onClose={() =>
            startTransition(() => setShowMoneyTransferModal(false))
          }
          onSubmit={() => {
            startTransition(() => setShowMoneyTransferModal(false));
          }}
        />
      )}

      {showSearchModal && (
        <TransactionsSearchModal
          onClose={() => startTransition(() => setShowSearchModal(false))}
          onSubmit={(filterOptions) =>
            startTransition(() => {
              setMainFilter({
                ...mainFilter,
                ...filterOptions,
              });
              setShowSearchModal(false);
            })
          }
        />
      )}

      {showTableSettingsModal && <TableSettingsModal />}

      {showContactQrCode && <CurrentUserQrContact />}

      {showCreatePassKey && (
        <RegisterPassKeyModal
          onClose={() => startTransition(() => setShowCreatePassKey(false))}
        />
      )}

      {showChangePassword && (
        <ChangePasswordModal
          onClose={() => startTransition(() => setShowChangePassword(false))}
        />
      )}
    </>
  );
};

export default ModalsLoader;
